import * as React from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useGetDogovorsQuery } from "../../../store/dogovorApi";
import { convertToRuFormat } from "../../../utilits/helpers/convertDateFormat";
import {
  dateForNotification,
  countDayOfExperiation,
} from "../../../utilits/functionsForConstant";

function Row({ row }) {
  const [openFirst, setOpenFirst] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpenFirst(!openFirst)}
          >
            {openFirst ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.attributes.contragent.data[0].attributes.surname +
            " " +
            row.attributes.contragent.data[0].attributes.name +
            " " +
            row.attributes.contragent.data[0].attributes.lastname}
        </TableCell>
        <TableCell align="center">№{row.attributes.numberDogovor}</TableCell>
        <TableCell align="center">{row.attributes.totalSum}</TableCell>
        <TableCell align="center">
          {convertToRuFormat(row.attributes.dateDogovorFrom)}
        </TableCell>
        <TableCell align="center">
          {convertToRuFormat(row.attributes.dateDogovorTo)}
        </TableCell>
        <TableCell align="center">
          {countDayOfExperiation(row.attributes.dateDogovorTo)}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={openFirst} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Номенклатура
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Наименование</TableCell>
                    <TableCell>Адрес</TableCell>
                    <TableCell>Идентификационный код</TableCell>
                    <TableCell>Площадь</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {row.attributes.nomenklatura.data[0].attributes.name}
                    </TableCell>
                    <TableCell>
                      {row.attributes.nomenklatura.data[0].attributes.address +
                        " " +
                        row.attributes.nomenklatura.data[0].attributes
                          .addressNumber}
                    </TableCell>
                    <TableCell>
                      {row.attributes.nomenklatura.data[0].attributes.inventNumber}
                    </TableCell>
                    <TableCell>
                      {row.attributes.nomenklatura.data[0].attributes.square} кв.м.
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function CollapsibleTable() {
  const { data: dogovorsFB } = useGetDogovorsQuery(
    "?sort[0]=id:asc&populate[1]=contragent&populate[2]=nomenklatura",
    { refetchOnMountOrArgChange: true }
  );
  const [rows, setRows] = React.useState([]);

  const experiationDateDogovors = rows.filter(
    (item) =>
      new Date(item.attributes.dateDogovorTo) < dateForNotification() &&
      new Date(item.attributes.dateDogovorTo) > new Date()
  );

  React.useEffect(() => {
    const setDataToStates = async () => {
      try {
        const dogovors = await dogovorsFB.data;
        setRows(dogovors);
      } catch (error) {}
    };
    setDataToStates();
  }, [dogovorsFB]);

  return (
    <>
      <div style={{ margin: "20px 0 20px 20px" }}>
        <Typography variant="h5" gutterBottom component="div">
          Сформирован на: {convertToRuFormat(new Date())}
        </Typography>
      </div>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>
                <Typography variant="h5" gutterBottom component="div">
                  Контрагент
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h5" gutterBottom component="div">
                  Договор
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h5" gutterBottom component="div">
                  Сумма
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h5" gutterBottom component="div">
                  Дата начало
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h5" gutterBottom component="div">
                  Дата окончания
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="h5" gutterBottom component="div">
                  Осталось дней:
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {experiationDateDogovors.map((row) => (
              <Row key={row.id} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
